import React from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export type Props = React.HTMLAttributes<HTMLDivElement> & {
    label: string // Used by <Tabs>
    icon?: IconProp // Used by <Tabs>
    children: React.ReactNode
}

const Tab = ({ children, ...props }: Props): React.ReactElement => {
    return <div {...props}>{children}</div>
}

export default Tab
